import { semanticColors } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function SystemCheckCircle({
  width = 20,
  height = 20,
  fill = semanticColors.success.regular,
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77083 11.8959L6.72916 9.85419C6.60416 9.72919 6.45139 9.66669 6.27083 9.66669C6.09028 9.66669 5.9375 9.72919 5.8125 9.85419C5.67361 9.99308 5.60416 10.1563 5.60416 10.3438C5.60416 10.5313 5.66666 10.6875 5.79166 10.8125L8.33333 13.3542C8.44444 13.4653 8.59028 13.5209 8.77083 13.5209C8.95139 13.5209 9.09722 13.4653 9.20833 13.3542L14.2083 8.35419C14.3333 8.22919 14.3958 8.07641 14.3958 7.89585C14.3958 7.7153 14.3264 7.55558 14.1875 7.41669C14.0625 7.29169 13.9062 7.22919 13.7187 7.22919C13.5312 7.22919 13.3681 7.29863 13.2292 7.43752L8.77083 11.8959ZM10 18.3334C8.81944 18.3334 7.72222 18.1215 6.70833 17.6979C5.69444 17.2743 4.8125 16.6875 4.0625 15.9375C3.3125 15.1875 2.72569 14.3056 2.30208 13.2917C1.87847 12.2778 1.66666 11.1806 1.66666 10C1.66666 8.83335 1.87847 7.74308 2.30208 6.72919C2.72569 5.7153 3.3125 4.83335 4.0625 4.08335C4.8125 3.33335 5.69444 2.74308 6.70833 2.31252C7.72222 1.88196 8.81944 1.66669 10 1.66669C11.1667 1.66669 12.2569 1.88196 13.2708 2.31252C14.2847 2.74308 15.1667 3.33335 15.9167 4.08335C16.6667 4.83335 17.2569 5.7153 17.6875 6.72919C18.1181 7.74308 18.3333 8.83335 18.3333 10C18.3333 11.1806 18.1181 12.2778 17.6875 13.2917C17.2569 14.3056 16.6667 15.1875 15.9167 15.9375C15.1667 16.6875 14.2847 17.2743 13.2708 17.6979C12.2569 18.1215 11.1667 18.3334 10 18.3334Z"
        fill={fill}
      />
    </Svg>
  );
}
